import React from 'react';
import { SetupIntro } from '@Components/Category/SetupIntro.component';

export const CoFSetupIntro = () => <SetupIntro section="cof" />;
